<div class="content">
  <span class="spinner-container d-flex"  [hidden]="!loading">
    <mat-spinner class="accent-spinner" diameter="40"></mat-spinner>
  </span>
  <div [hidden]="loading" class="my-show-table enhanced-box">
    <div class="mat-elevation-z8 ex">
      <table  mat-table [dataSource]="dataSource" class="mat-elevation-z8" matSort>
        <ng-container matColumnDef="show_code">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Shows </th>
          <td mat-cell *matCellDef="let element"> {{element.show_code}} </td>
        </ng-container>
        <ng-container matColumnDef="listeners">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Listeners </th>
          <td mat-cell *matCellDef="let element"> {{element.listeners}} </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        <tr class="mat-row" *matNoDataRow>
          <td colspan="8" class="mat-cell">{{ loading ? 'Loading...':'No records found.'}}</td>
        </tr>
      </table>
      <mat-paginator [class]="total_reports > 5 ? '' : 'hidden_dropdown'" [pageSizeOptions]="[5]" [pageSize]="5"aria-label="Select page of the records."></mat-paginator>
    </div>
    <h3 class="stats-text">
      User Total Shows are <strong>{{ totalShows }}</strong> and Total Listeners of all shows are <strong>{{ totalListeners }}</strong> (including manual count).
    </h3>

    <h4 class="form-title" style="display: flex;align-items: center;gap: 5px;">
      <mat-icon class="form-icon">group_add</mat-icon>
      Set Additional Listeners Manually <small>(This count will be added to the total listeners count of all the shows)</small>
    </h4>

    <form [formGroup]="addShows" class="billing-form form-container">
      <mat-form-field appearance="fill" class="full-width">
        <mat-label>Listeners Count</mat-label>
        <input matInput formControlName="Listeners" placeholder="Enter number of listeners" type="number"  required   />
      </mat-form-field>
       <button class="popup-save" mat-flat-button
            [ngStyle]="{'background-color': 'var(--primary-color)', 'color': 'var(--light-color)'}" type="submit"
            (click)="billingInfo()" [disabled]="processing">
            <mat-icon *ngIf="processing">
                <mat-spinner class="accent-spinner" diameter="20"></mat-spinner>
            </mat-icon>
           <mat-icon>add</mat-icon>Set Listeners
        </button>
      </form>
      <span *ngIf="processing">Processing...</span>
      <span *ngIf="error_massage" class="ErrorMessage shake">{{ error_massage }}</span>
  </div>
</div>